import { Component } from 'react';
import GameData from "../mobx/GameData";
import { observe } from "mobx";
import { Button, Card, Dropdown, Alert } from "react-bootstrap";

import './LevelTilesPage.scss';
import { ChrFile } from "../components/nes/ChrFile";
import { PalettePreview } from "../components/nes/PalettePreview";
import { getCollisionType } from "../data/CollisionType";
import ApplicationState from "../mobx/ApplicationState";

import { Col, Row, Container } from "react-bootstrap";
import { coerceUnknownFields } from '../data/BaseGame';

export default class LevelTilesPage extends Component {

    gameDataCleanup = null;

    constructor(props) {
        super(props);
        const game = coerceUnknownFields(GameData.currentGame)

        this.state = {
            gameTiles: JSON.parse(JSON.stringify(game.tileData)),
            palettes: [
                game.gamePaletteData.slice(0, 4),
                game.gamePaletteData.slice(4, 8),
                game.gamePaletteData.slice(8, 12),
                game.gamePaletteData.slice(12, 16)
            ],
            tileValidationState: game.tileData.map(a => true),
            validationMessage: null
        };
        
    }

    componentDidMount() {
        this.gameDataCleanup = observe(GameData, () => { 
            this.forceUpdate()
        });
        this.forceUpdate();
    }

    componentWillUnmount() {
        if (this.gameDataCleanup) {
            this.gameDataCleanup();
        }
    }

    setPalette(tileId, paletteId) {
        const newGameTiles = Array.from(this.state.gameTiles);
        newGameTiles[tileId].palette = paletteId;
        this.setState({
            gameTiles: newGameTiles
        });
    }

    setCollision(tileId, collId) {
        const newGameTiles = Array.from(this.state.gameTiles);
        newGameTiles[tileId].collision = collId;
        this.setState({
            gameTiles: newGameTiles
        });
    }

    validateTiles() {
        const { gameTiles } = this.state;
        let validationMessage = null,
            walkableSwitchCount = 0,
            solidSwitchCount = 0,
            switchTileCount = 0,
            tileValidationState = gameTiles.map(a => true);
        for (let i = 0; i < gameTiles.length; i++) {
            const collType = gameTiles[i].collision;
            if (collType === 13) { 
                solidSwitchCount++; 
            } else if (collType === 14) {
                walkableSwitchCount++;
            } else if (collType === 12) {
                switchTileCount++;
            }
        }
        if (switchTileCount > 0) {
            if (solidSwitchCount > 1) {
                validationMessage = 'Only one Switchable Block of each type is allowed with a switch.';
                for (let i = 0; i < gameTiles.length; i++) {
                    if (gameTiles[i].collision === 13) {
                        tileValidationState[i] = false;
                    }
                }
            }
            if (walkableSwitchCount > 1) {
                validationMessage = 'Only one Switchable Block of each type is allowed with a switch.';
                for (let i = 0; i < gameTiles.length; i++) {
                    if (gameTiles[i].collision === 14) {
                        tileValidationState[i] = false;
                    }
                }
            }

            if (!validationMessage) {
                if (solidSwitchCount === 0 && walkableSwitchCount > 0) {
                    validationMessage = 'You must include a Solid Switchable Block for the switch to work.';
                } else if (walkableSwitchCount === 0 && solidSwitchCount > 0) {
                    validationMessage = 'You must include a Walkable Switchable Block for the switch to work.';
                }
            }

        }
        this.setState({ tileValidationState, validationMessage })
        return !validationMessage;
    }

    saveChanges() {
        if (!this.validateTiles()) {
            return;
        }
        GameData.replaceCurrentGame({
            ...GameData.currentGame,
            tileData: this.state.gameTiles
        });

        ApplicationState.addAlert('success', 'Tile changes have been saved!');
    }

    render() {
        return (
            <div className="tiles-page">
                <Container>
                    <Row>
                        <Col>


                                <h1>Map Tiles</h1>
                                <p className="mt-3">
                                    This page allows you to configure the tiles, or "blocks" available for use in your levels. You can configure their colors, and how 
                                    they respond to the player trying to pass through them, as well as which of your color palettes they use.
                                </p>
                                

                                <div className="mt-3">
                                    {this.state.gameTiles.map((tile, idx) => (
                                        <Card key={'game-tile-' + idx} className={`game-tile ${this.state.tileValidationState[idx] ? 'valid' : 'invalid'}`}>
                                            <Card.Body>
                                                <ChrFile isMeta={true} data={GameData.currentGame.gameGraphicsTiles} palette={this.state.palettes[tile.palette]} tileId={idx} />
                                                <div className="mb-1">
                                                    <table><tbody><tr><td>
                                                        Palette: 
                                                    </td>
                                                    <td>
                                                        <Dropdown className="palette-dropdown">
                                                            <Dropdown.Toggle variant="outline-secondary" size="sm" id={"dd-palette-toggle" + idx}>
                                                                Palette {tile.palette + 1}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {[0,1,2,3].map(paletteId => (
                                                                    <Dropdown.Item key={"pal-dd-option-" + idx + '-' + paletteId} onClick={() => this.setPalette(idx, paletteId)} className={tile.palette === paletteId ? 'active' : ''}>
                                                                        Palette {paletteId + 1}
                                                                        <PalettePreview palette={this.state.palettes[paletteId]} />
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td></tr></tbody></table>
                                                </div>
                                                <div className="mb-1">
                                                    <table><tbody><tr><td>
                                                        Collision:
                                                    </td>
                                                    <td>
                                                        <Dropdown className="collision-dropdown">
                                                            <Dropdown.Toggle variant="outline-secondary" size="sm" id={"dd-collision-toggle" + idx}>
                                                                <span>{getCollisionType(tile.collision)}</span>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {[0, 1, 3, 6, 2, 4, 5, 8, 9, 10, 12, 13, 14, 7, 11, 255].map(collId => (
                                                                    <Dropdown.Item key={"coll-dd-option-" + idx + '-' + collId} onClick={() => this.setCollision(idx, collId)} className={tile.collision === collId ? 'active' : ''}>
                                                                        {getCollisionType(collId)}
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td></tr></tbody></table>

                                                </div>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                                <div className="button-footer-bar">
                                    {this.state.validationMessage ? 
                                        <Alert variant="warning">{this.state.validationMessage}</Alert> :
                                        <></>
                                    }
                                    <Button variant="primary" onClick={() => this.saveChanges()}>Save Changes</Button>
                                </div>

                            </Col>
                        </Row>
                    </Container>
            </div>
        );
    }
}